import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import FormControlLabelPlacement from './FormControlLabelPlacement';
import ClientProvider from './client';
export default createDemo(import.meta.url, FormControlLabelPlacement, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/radio-buttons/demos/form-control-label-placement/FormControlLabelPlacement.tsx",
    "fileName": "FormControlLabelPlacement.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Radio from '@mui/material/Radio';\nimport RadioGroup from '@mui/material/RadioGroup';\nimport FormControlLabel from '@mui/material/FormControlLabel';\nimport FormControl from '@mui/material/FormControl';\nimport FormLabel from '@mui/material/FormLabel';\n\nexport default function FormControlLabelPlacement() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 1,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const id = React.useId();\n  return (\n    <FormControl>\n      <FormLabel id={`${id}-label`}>Label placement</FormLabel>\n      <RadioGroup\n        row\n        aria-labelledby={`${id}-label`}\n        name=\"position\"\n        defaultValue=\"top\"\n      >\n        <FormControlLabel\n          value=\"bottom\"\n          control={<Radio />}\n          label=\"Bottom\"\n          labelPlacement=\"bottom\"\n        />\n        <FormControlLabel value=\"end\" control={<Radio />} label=\"End\" />\n      </RadioGroup>\n    </FormControl>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 29,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Radio from '@mui/material/Radio';\nimport RadioGroup from '@mui/material/RadioGroup';\nimport FormControlLabel from '@mui/material/FormControlLabel';\nimport FormControl from '@mui/material/FormControl';\nimport FormLabel from '@mui/material/FormLabel';\n\nexport default function FormControlLabelPlacement() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 1
        },
        "  const id = React.useId();\n  return (\n    <FormControl>\n      <FormLabel id={`${id}-label`}>Label placement</FormLabel>\n      <RadioGroup\n        row\n        aria-labelledby={`${id}-label`}\n        name=\"position\"\n        defaultValue=\"top\"\n      >\n        <FormControlLabel\n          value=\"bottom\"\n          control={<Radio />}\n          label=\"Bottom\"\n          labelPlacement=\"bottom\"\n        />\n        <FormControlLabel value=\"end\" control={<Radio />} label=\"End\" />\n      </RadioGroup>\n    </FormControl>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 29,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Radio",
      "@mui/material/RadioGroup",
      "@mui/material/FormControlLabel",
      "@mui/material/FormControl",
      "@mui/material/FormLabel"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
